import { CategoryDatum, Statistics } from '../types';

export type SortingMethod =
  | 'none'
  | 'asc-key'
  | 'desc-key'
  | 'asc-value'
  | 'desc-value'
  | string[]
  | ((a: CategoryDatum, b: CategoryDatum) => 1 | -1);

export const getSortingMethod: (sortingMethod: SortingMethod) => (a: CategoryDatum, b: CategoryDatum) => 1 | -1 = (
  sortingMethod
) => {
  if (sortingMethod === 'asc-key') {
    return (a: CategoryDatum, b: CategoryDatum) =>
      a.key === b.key ? (a.value > b.value ? -1 : 1) : a.key < b.key ? -1 : 1;
  } else if (sortingMethod === 'desc-key') {
    return (a: CategoryDatum, b: CategoryDatum) =>
      a.key === b.key ? (a.value > b.value ? 1 : -1) : a.key < b.key ? 1 : -1;
  } else if (sortingMethod === 'asc-value') {
    return (a: CategoryDatum, b: CategoryDatum) =>
      a.value === b.value ? (a.key > b.key ? -1 : 1) : a.value < b.value ? -1 : 1;
  } else if (sortingMethod === 'desc-value') {
    return (a: CategoryDatum, b: CategoryDatum) =>
      a.value === b.value ? (a.key > b.key ? 1 : -1) : a.value < b.value ? 1 : -1;
  } else if (typeof sortingMethod === 'function') {
    return sortingMethod;
  } else if (Array.isArray(sortingMethod)) {
    return (a: CategoryDatum, b: CategoryDatum) => {
      if (sortingMethod.indexOf(a.key) === -1) {
        return 1;
      }
      if (sortingMethod.indexOf(b.key) === -1) {
        return -1;
      }

      return sortingMethod.indexOf(a.key) === sortingMethod.indexOf(b.key)
        ? a.key > b.key
          ? 1
          : -1
        : sortingMethod.indexOf(a.key) < sortingMethod.indexOf(b.key)
        ? -1
        : 1;
    };
  }
  return () => 1;
};

export const isValidDate = (value: string) => {
  const date = new Date(value);
  return !isNaN(date.getTime()) && date.toISOString().startsWith(value);
};

export const mergeLegends = (arr1: Statistics, arr2: Statistics) => {
  const map = new Map();

  [...arr1, ...arr2].forEach((item) => {
    map.set(item.key, item.value);
  });

  return Array.from(map, ([key, value]) => ({ key, value }));
};
